import { navigate } from 'gatsby'

export const replaceRoute = url => navigate(url, { replace: true })
